import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, VERSION, ViewChild,OnChanges, SimpleChanges } from '@angular/core';
import { OdrService } from '../service/odr.service';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { AppServiceService } from '../service/app-service.service';
import { filter, map, pairwise, switchMap } from 'rxjs/operators';
import { RouterExtService } from '../shared/routerext.service';
import { VCard } from 'ngx-vcard';



export class people {
  name: string;
  department: string;
  userId: string;
  iamId: number;
  telephoneNumber: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  firsName: string;
  lastName: string;
  title: string;
  mail: string;
  website: string;
  pronouns: string;
  orgPersonOrder: string;
  phoneOrder: string;
  major: string;
  is_student: string;
  student_level: string;
  fax : string;
  cellular: string;
  pager: string;
  tdd: string;
  vCard: VCard;
}

@Component({
  selector: 'app-people-list',
  templateUrl: './people-list.component.html',
  styleUrls: ['./people-list.component.css']
})
export class PeopleListComponent implements OnInit  {

  searchValue: string;
 
  public reactiveForm: FormGroup = new FormGroup({
    recaptchaReactive: new FormControl(null, Validators.required)
  });
  isCaptchaSuccess: boolean = false;
  hasCaptchaExpired: boolean = false;
  //@ViewChild('captchaElem', { static: true }) captchaElem: ReCaptcha2Component;
  //@ViewChild('searchValue') langInput: ElementRef;
  
  peopleList: Array<people>;
  hasNoRecords: boolean = false;
  peopleAuthText: string;
  public log: string[] = [];
  tempSearchValue: String = '';
  constructor(private odrService: OdrService, 
    public formBuilder: FormBuilder,  
    private cdr: ChangeDetectorRef, 
    private appService: AppServiceService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routerExtService: RouterExtService) {
      
    this.activatedRoute.params.subscribe(params => {
      this.searchValue = params['searchQuery'];
        this.setUrls();
        if(this.isCaptchaSuccess){
          this.getPeopleSearch();
        } else {
          this.peopleList = [];
        }
      });
    //   this.odrService.getIpClient().subscribe(res => {
    //     console.log('res ', res);
    //                         console.log('res.json() ', res);
                            
    //  });
   }

   setUrls(): void {
    let prvUrl = this.routerExtService.getPreviousUrl();
    
    this.appService.searchString.subscribe(value => this.tempSearchValue = value);
    if(prvUrl == '/people-details' && this.tempSearchValue == this.searchValue){
      this.getPeopleSearch();
      setTimeout(() => {
      this.isCaptchaSuccess = false;
      this.hasCaptchaExpired = true;
      console.log('text....')
    }, 30000);
    }
   }
  
  
  ngOnInit(): void {
    this.appService.setTitle('Search UC Davis Directory: Results');
    
    this.router.events.subscribe ((evt) => {
      if (!(evt instanceof NavigationEnd)) {
             return;
      }
      window.scrollTo(0,0)
});

  }
 

  getPeopleSearch (): void {

  if (this.searchValue && this.searchValue !== '' && this.searchValue.length >= 2) {
    this.appService.setSearchString(this.searchValue);
    this.odrService.getPeopleList().subscribe(testStr => {
      this.odrService.lookupPerson(this.searchValue, testStr['getKey']).subscribe(data => {
        this.peopleList = data;
        if(this.peopleList.length == 0) {
          this.hasNoRecords = true;
        } else {
          this.hasNoRecords = false;
        }
     });
    });   
  } else {
    this.hasNoRecords = true;
  }
 }


  addTokenLog(message: string, token: any): void {
    if(token.target.checked == true){
      this.isCaptchaSuccess = true;
      this.hasCaptchaExpired = false;
    } else {
      this.isCaptchaSuccess = false;
    }
    setTimeout(() => {
      this.isCaptchaSuccess = false;
      this.hasCaptchaExpired = true;
      console.log('text....')
    }, 30000);
    this.getPeopleSearch();
  }


}

